module.exports = __webpack_public_path__ + "static/media/under_construction.c6b43a6f.jpg";